var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
var SyndicateBasicMeta = /** @class */ (function (_super) {
    __extends(SyndicateBasicMeta, _super);
    function SyndicateBasicMeta(notificationService, i18N, tokenClient, dialogClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        _this.dialogClientService = dialogClientService;
        _this.displayMemberPath = function (item) { return item.lottery.name; };
        return _this;
    }
    Object.defineProperty(SyndicateBasicMeta.prototype, "showManageTemplate", {
        get: function () {
            return this.item.navigationInfo && this.item.navigationInfo.brandId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SyndicateBasicMeta.prototype, "availableBonusPicks", {
        get: function () {
            return this.item ? this.item.availableBonusPicks : null;
        },
        set: function (x) {
            this.item.availableBonusPicks = x;
            this.generate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SyndicateBasicMeta.prototype, "availableMainPicks", {
        get: function () {
            return this.item ? this.item.availableMainPicks : null;
        },
        set: function (x) {
            this.item.availableMainPicks = x;
            this.generate();
        },
        enumerable: false,
        configurable: true
    });
    SyndicateBasicMeta.prototype.editBranding = function () {
        require("../dialogs/syndicate-branding-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.SyndicateBranding, this.item, false, false, true);
    };
    SyndicateBasicMeta.prototype.generate = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        if (this.isGenerating) {
            this.shouldRegenerate = true;
            return;
        }
        this.isGenerating = true;
        var combinations = [];
        var mainPicks = this.item.availableMainPicks ? this.generateInternal(this.item.availableMainPicks.split(","), this.item.drawnNumbers) : [];
        var bonusPicks = this.item.drawnBonusNumbers && this.item.availableBonusPicks ? this.generateInternal(this.item.availableBonusPicks.split(","), this.item.drawnBonusNumbers) : [];
        try {
            // generate combinations
            for (var mainPicks_1 = __values(mainPicks), mainPicks_1_1 = mainPicks_1.next(); !mainPicks_1_1.done; mainPicks_1_1 = mainPicks_1.next()) {
                var mPick = mainPicks_1_1.value;
                if (bonusPicks.length > 0)
                    try {
                        for (var bonusPicks_1 = (e_2 = void 0, __values(bonusPicks)), bonusPicks_1_1 = bonusPicks_1.next(); !bonusPicks_1_1.done; bonusPicks_1_1 = bonusPicks_1.next()) {
                            var bPick = bonusPicks_1_1.value;
                            combinations.push({ bonus: bPick, main: mPick });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (bonusPicks_1_1 && !bonusPicks_1_1.done && (_b = bonusPicks_1.return)) _b.call(bonusPicks_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                else
                    combinations.push({ bonus: null, main: mPick });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mainPicks_1_1 && !mainPicks_1_1.done && (_a = mainPicks_1.return)) _a.call(mainPicks_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.item.numberOfLines = combinations.length;
        this.item.syndicateGeneratedNumbers.splice(0, this.item.syndicateGeneratedNumbers.length);
        setTimeout(function () {
            var e_3, _a;
            try {
                for (var combinations_1 = __values(combinations), combinations_1_1 = combinations_1.next(); !combinations_1_1.done; combinations_1_1 = combinations_1.next()) {
                    var combination = combinations_1_1.value;
                    _this.item.syndicateGeneratedNumbers.push({
                        mainPicks: combination.main,
                        bonusPicks: combination.bonus
                    });
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (combinations_1_1 && !combinations_1_1.done && (_a = combinations_1.return)) _a.call(combinations_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            _this.isGenerating = false;
            if (_this.shouldRegenerate) {
                _this.shouldRegenerate = false;
                _this.generate();
            }
        });
    };
    SyndicateBasicMeta.prototype.generateInternal = function (set, lineLength) {
        var result = [];
        function MakeCombination(indexes) {
            var setarr = [];
            for (var i = 0; i < indexes.length; ++i)
                setarr[i] = set[indexes[i]];
            return setarr.join(',');
        }
        var Nsize = set.length;
        if (Nsize < lineLength) {
            return [];
        }
        var arr = [];
        for (var i = 0; i < lineLength; ++i)
            arr[arr.length] = i;
        var combination = MakeCombination(arr);
        result.push(combination);
        while (true) {
            var i = lineLength - 1;
            while (i >= 0 && arr[i] == Nsize - lineLength + i)
                i--;
            if (i < 0)
                break;
            arr[i] += 1;
            for (var j = i + 1; j < lineLength; ++j)
                arr[j] = arr[j - 1] + 1;
            var combination = MakeCombination(arr);
            result.push(combination);
        }
        return result;
    };
    SyndicateBasicMeta.prototype.removeSyndicateGeneratedNumbers = function (index) {
        this.item.syndicateGeneratedNumbers.splice(index, 1);
    };
    SyndicateBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            TokenClient, DialogClientService])
    ], SyndicateBasicMeta);
    return SyndicateBasicMeta;
}(ChildComponent));
export { SyndicateBasicMeta };
